module.exports = __webpack_public_path__ + "images/category_lp/watch/bg-wave_d3ce877947d54709fb3bb0a6c15222eb.png";